$(document).ready(function(){
  if ($('.blockArticle img').length) {
    var bodyHeight = $('body').height()-$(window).height();
    window.onscroll = function() {
      var deg = window.scrollY*(720/bodyHeight);
      $('.blockArticle img').css({
        'transform': 'rotate('+deg+'deg)',
      });
    };
  }
});